import React, { useState, useEffect } from "react";
import { AgChartsReact } from "ag-charts-react";
import { server } from "../../App";
import { useQuery } from "react-query";
import axios from "axios";
import moment from "moment";
import { Form, Dropdown } from "semantic-ui-react";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useWindowSize } from "react-use";
import useGetDoctorsSemanticUI from "../../CustomHooks/useGetDoctorsSemanticUI"


function Months() {
  const [day, setDay] = useState(moment().format("YYYY-MM-DD"));
  const [fk_id_medecin1, setfk_id_medecin1] = useState(0);
  const { width } = useWindowSize();
  const Doctors = useGetDoctorsSemanticUI()

  let myObject = { key: "0000000A", text: "Global", value: 0 }
  let myObject2 = Doctors?.Doctors_list ? Doctors?.Doctors_list : []

  myObject2.push(myObject)

  const getDataDetails = () => {
    let url;

    // DEV
    // if (fk_id_medecin1 == 0) {
    //   url = `${server}AnnualRevenu/StatisticsRoutes/GetRevenuByDayDetails/${day}`;
    // } else {
    //   url = `${server}AnnualRevenu/StatisticsRoutes/GetRevenuByDayDetailsOneDoctor/${day}/${fk_id_medecin1}`;
    // }

    // PROD
    if (fk_id_medecin1 == 0) {
      url = `${server}StatisticsRoutes/GetRevenuByDayDetails/${day}`;
    } else {
      url = `${server}StatisticsRoutes/GetRevenuByDayDetailsOneDoctor/${day}/${fk_id_medecin1}`;
    }

    return axios
      .get(url, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => response.data);
  };
  const { data: dataDetails, refetch: refetchDetails } = useQuery(
    "MonthsDetails",
    () => {
      return getDataDetails();
    }
  );

  useEffect(() => {
    refetchDetails();
  }, [day, fk_id_medecin1]);

  const getData = () => {
    let url;


    // DEV
    // if (fk_id_medecin1 == 0) {
    //   url = `${server}AnnualRevenu/StatisticsRoutes/GetRevenuByDay/${day}`;
    // } else {
    //   url = `${server}AnnualRevenu/StatisticsRoutes/GetRevenuByDayOneDoctor/${day}/${fk_id_medecin1}`;
    // }

    // PROD
    if (fk_id_medecin1 == 0) {
      url = `${server}StatisticsRoutes/GetRevenuByDay/${day}`;
    } else {
      url = `${server}StatisticsRoutes/GetRevenuByDayOneDoctor/${day}/${fk_id_medecin1}`;
    }

    return axios
      .get(url, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => response.data);
  };
  const { data, refetch } = useQuery("Months", () => {
    return getData();
  });

  useEffect(() => {
    refetch();
  }, [day, fk_id_medecin1]);

  let options = {
    title: {
      text: "Revenu Journalier",
    },
    subtitle: {
      text: "En Dirham",
    },
    data: data,
    series: [
      {
        type: "column",
        xKey: "jour",
        yKeys: ["Total"],
      },
    ],
    legend: {
      position: 'bottom',
    },
  };

  let angle
  if (width < 512) {
    angle = 359
  } else {
    angle = 30
  }

  let options2 = {
    title: {
      text: "Revenu par acte",
    },
    subtitle: {
      text: "Journalier",
    },
    data: dataDetails,
    series: [
      {
        type: "pie",
        labelKey: "Acte",
        angleKey: "Total",
        label: {
          minAngle: angle
        }
      },
    ],
    legend: {
      position: 'bottom',
    },
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      fontWeight: 900,
      fontSize: "1.2rem",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  return (
    <>
      <div className="FixingAbigProblem">


        <div className="field" style={{ display: "grid" }}>
          <label>Date</label>
          <div className="ui input">
            <input
              defaultValue={day}
              type="date"
              name="date_naissance"
              required
              min="1900-01-01"
              max="3018-12-31"
              onChange={(e) => setDay(e.target.value)}
            ></input>
          </div>
        </div>



        <Form.Field
          // className="TinySelect"
          value={fk_id_medecin1}
          search
          selection
          fluid
          label="Médecin"
          control={Dropdown}
          options={myObject2}
          // placeholder="Médecin"
          onChange={(e, data) => {
            setfk_id_medecin1(data.value);
          }}
        />


      </div>
      <AgChartsReact options={options} />

      {/* <div className="fixingAbigproblem2">

        <Form.Field
          className="TinySelect"
          value={Month}
          search
          selection
          fluid
          label="Mois"
          control={Dropdown}
          options={MonthsOptions}
          placeholder="Mois"
          onChange={(e, data) => {
            setMonth(data.value);
          }}
        />


      </div> */}
      <AgChartsReact options={options2} />

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 260 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Acte</StyledTableCell>
              <StyledTableCell>Nb</StyledTableCell>
              <StyledTableCell>Total</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataDetails?.map((item, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell>{item.Acte}</StyledTableCell>
                <StyledTableCell>{item.Nombre}</StyledTableCell>
                <StyledTableCell>{new Intl.NumberFormat('de-DE').format(item.Total)}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default Months;
